import { GPTGameIcon } from 'src/EXPERIMENTAL_LIB/modules/gpt/icons';

export const WheelEventIcon: GPTGameIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}>
    <g clip-path="url(#clip0_3026_520)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.37 5.71C13.48 5.99 11.79 6.9 9.60999 7.76C7.42999 8.62 5.55999 9.08 5.45999 8.8C5.35999 8.52 7.03999 7.61 9.21999 6.75C11.4 5.89 13.27 5.43 13.38 5.71H13.37Z"
        fill="url(#paint0_linear_3026_520)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.23 5.78C13.31 5.99 11.67 6.82 9.56001 7.64C7.45001 8.46 5.68001 8.96 5.60001 8.75C5.52001 8.54 7.16001 7.71 9.27001 6.89C11.38 6.07 13.15 5.57 13.23 5.78Z"
        fill="url(#paint1_linear_3026_520)"
        style={{ mixBlendMode: 'multiply' }}
      />
      <path
        d="M12.41 23.97C17.46 23.97 21.55 19.88 21.55 14.83C21.55 9.78 17.46 5.69 12.41 5.69C7.36 5.69 3.28 9.78 3.28 14.83C3.28 19.88 7.37 23.97 12.42 23.97H12.41Z"
        fill="#A15EFF"
      />
      <path
        d="M12.41 23.8C17.36 23.8 21.37 19.79 21.37 14.84C21.37 9.89 17.36 5.88 12.41 5.88C7.46001 5.88 3.45001 9.88 3.45001 14.83C3.45001 19.78 7.46001 23.79 12.41 23.79V23.8Z"
        fill="#8935FF"
      />
      <path
        d="M12.41 22.9C16.87 22.9 20.48 19.29 20.48 14.83C20.48 10.37 16.87 6.76 12.41 6.76C7.95 6.76 4.34 10.37 4.34 14.83C4.34 19.29 7.95 22.9 12.41 22.9Z"
        fill="#742DD9"
      />
      <g id="wheel-rotating">
        <path
          d="M19.88 12.83C19.54 11.56 18.87 10.36 17.88 9.37L12.42 14.83L19.89 12.83H19.88Z"
          fill="#F8203D"
        />
        <path
          d="M12.41 14.83L19.88 16.83C20.23 15.52 20.23 14.14 19.88 12.83L12.41 14.83Z"
          fill="white"
        />
        <path
          d="M12.41 14.83L17.87 9.37C16.87 8.37 15.67 7.71 14.41 7.37L12.41 14.84V14.83Z"
          fill="white"
        />
        <path
          d="M12.41 14.83L10.41 22.3C11.72 22.65 13.1 22.65 14.41 22.3L12.41 14.83Z"
          fill="#F8203D"
        />
        <path
          d="M14.42 22.3C15.69 21.96 16.89 21.29 17.88 20.3L12.42 14.84L14.42 22.31V22.3Z"
          fill="white"
        />
        <path
          d="M6.95001 20.3C7.95001 21.3 9.15001 21.96 10.41 22.3L12.41 14.83L6.95001 20.29V20.3Z"
          fill="white"
        />
        <path
          d="M12.41 14.83L17.87 20.29C18.87 19.29 19.53 18.09 19.87 16.83L12.4 14.83H12.41Z"
          fill="#F8203D"
        />
        <path
          d="M12.41 14.83L4.93999 12.83C4.58999 14.14 4.58999 15.52 4.93999 16.83L12.41 14.83Z"
          fill="white"
        />
        <path
          d="M12.41 14.83L10.41 7.36C9.14001 7.7 7.94001 8.37 6.95001 9.36L12.41 14.82V14.83Z"
          fill="white"
        />
        <path
          d="M6.95001 9.37C5.95001 10.37 5.29001 11.57 4.95001 12.83L12.42 14.83L6.96001 9.37H6.95001Z"
          fill="#F8203D"
        />
        <path
          d="M12.41 14.83L4.94 16.83C5.28 18.1 5.95 19.3 6.94 20.29L12.4 14.83H12.41Z"
          fill="#F8203D"
        />
        <path
          d="M14.42 7.37C13.11 7.02 11.73 7.02 10.42 7.37L12.42 14.84L14.42 7.37Z"
          fill="#F8203D"
        />

        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          from="0 12.41 14.83"
          to="360 12.41 14.83"
          dur="8s"
          repeatCount="indefinite"
        />
      </g>
      <path
        d="M12.69 6.48C12.73 6.33 12.64 6.17 12.49 6.13C12.34 6.09 12.18 6.18 12.14 6.33C12.1 6.48 12.19 6.64 12.34 6.68C12.49 6.72 12.65 6.63 12.69 6.48Z"
        fill="white"
      />
      <path
        d="M12.41 23.54C12.57 23.54 12.69 23.41 12.69 23.26C12.69 23.11 12.56 22.98 12.41 22.98C12.26 22.98 12.13 23.11 12.13 23.26C12.13 23.41 12.26 23.54 12.41 23.54Z"
        fill="white"
      />
      <path
        d="M8.45 7.4C8.53 7.54 8.48001 7.71 8.35001 7.79C8.21001 7.87 8.04 7.82 7.96 7.69C7.88 7.55 7.93001 7.38 8.06001 7.3C8.20001 7.22 8.37 7.27 8.45 7.4Z"
        fill="white"
      />
      <path
        d="M16.87 21.98C16.95 22.12 16.9 22.29 16.77 22.37C16.63 22.45 16.46 22.4 16.38 22.27C16.3 22.13 16.35 21.96 16.48 21.88C16.62 21.8 16.79 21.85 16.87 21.98Z"
        fill="white"
      />
      <path
        d="M5.26 10.37C5.4 10.45 5.44 10.62 5.36 10.76C5.28 10.9 5.11 10.94 4.97 10.86C4.83 10.78 4.79 10.61 4.87 10.47C4.95 10.33 5.12 10.29 5.26 10.37Z"
        fill="white"
      />
      <path
        d="M19.71 19.33C19.87 19.33 19.99 19.2 19.99 19.05C19.99 18.9 19.86 18.77 19.71 18.77C19.56 18.77 19.43 18.9 19.43 19.05C19.43 19.2 19.56 19.33 19.71 19.33Z"
        fill="white"
      />
      <path
        d="M4.27 14.9C4.31 14.75 4.21 14.59 4.06 14.56C3.91 14.52 3.75 14.62 3.72 14.77C3.68 14.92 3.78 15.08 3.93 15.11C4.08 15.15 4.24 15.05 4.27 14.9Z"
        fill="white"
      />
      <path
        d="M21.04 15.03C21.15 14.92 21.15 14.74 21.04 14.63C20.93 14.52 20.75 14.52 20.64 14.63C20.53 14.74 20.53 14.92 20.64 15.03C20.75 15.14 20.93 15.14 21.04 15.03Z"
        fill="white"
      />
      <path
        d="M5.12 19.33C5.28 19.33 5.4 19.2 5.4 19.05C5.4 18.9 5.27 18.77 5.12 18.77C4.97 18.77 4.84 18.9 4.84 19.05C4.84 19.2 4.97 19.33 5.12 19.33Z"
        fill="white"
      />
      <path
        d="M19.57 10.37C19.71 10.29 19.88 10.34 19.96 10.47C20.04 10.61 19.99 10.78 19.86 10.86C19.72 10.94 19.55 10.89 19.47 10.76C19.39 10.62 19.44 10.45 19.57 10.37Z"
        fill="white"
      />
      <path
        d="M7.95999 21.98C8.03999 21.84 8.20999 21.8 8.34999 21.88C8.48999 21.96 8.52999 22.13 8.44999 22.27C8.36999 22.41 8.19999 22.45 8.05999 22.37C7.91999 22.29 7.87999 22.12 7.95999 21.98Z"
        fill="white"
      />
      <path
        d="M16.66 7.82C16.82 7.8 16.92 7.66 16.9 7.5C16.88 7.34 16.74 7.24 16.58 7.26C16.42 7.28 16.32 7.42 16.34 7.58C16.36 7.74 16.5 7.84 16.66 7.82Z"
        fill="white"
      />
      <path
        d="M14.27 14.9C14.27 15.83 13.51 16.59 12.58 16.59C11.65 16.59 10.89 15.83 10.89 14.9C10.89 13.97 12.58 11.02 12.58 11.02C12.58 11.02 14.27 13.97 14.27 14.9Z"
        fill="#742DD9"
      />
      <path
        d="M13.41 14.98C13.48 14.52 13.17 14.09 12.71 14.01C12.25 13.94 11.82 14.25 11.74 14.71C11.67 15.17 11.98 15.6 12.44 15.68C12.9 15.75 13.33 15.44 13.41 14.98Z"
        fill="white"
      />
      <path
        opacity="0.15"
        d="M5.53 15.55C5.53 11.28 8.99 7.82 13.26 7.82C14.97 7.82 16.55 8.38 17.83 9.32C16.44 7.95 14.53 7.11 12.42 7.11C8.15 7.11 4.69 10.57 4.69 14.84C4.69 17.4 5.93 19.66 7.85 21.07C6.42 19.67 5.54 17.72 5.54 15.56L5.53 15.55Z"
        fill="black"
      />
      <path
        opacity="0.25"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.09003 9.37C5.09003 9.37 5.27003 9.68 7.36003 8.98C12.15 7.38 12.89 6.03 12.91 5.9C12.94 5.87 13.04 5.79 13.3 5.71C10.88 5.38 5.95003 7.98 5.81003 8.22C5.67003 8.46 5.60003 8.76 5.60003 8.76C5.60003 8.76 5.31003 9.1 5.09003 9.37Z"
        fill="black"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.39 4.43C4.39 4.43 4.35 3.5 4.43 3.14C4.43 3.14 6.35 3.02 7.1 4.01C7.1 4.01 7.33 6.4 6.22 6.24C5.11 6.08 4.39 4.43 4.39 4.43Z"
        fill="url(#paint2_linear_3026_520)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.14 1.8C11.14 1.8 10.54 1.09 10.24 0.88C10.24 0.88 8.74002 2.09 8.87002 3.33C8.87002 3.33 10.32 5.24 11.03 4.38C11.74 3.52 11.15 1.8 11.15 1.8H11.14Z"
        fill="url(#paint3_linear_3026_520)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.24 0.03C12.24 0.03 10.94 0.53 10.59 2.26C10.83 2.35 11.04 2.56 11.15 2.84C11.34 3.32 11.15 3.85 10.74 4.01C10.33 4.17 9.84001 3.91 9.65001 3.43C9.52001 3.11 9.56001 2.77 9.73001 2.53C9.17001 2.09 8.31001 1.58 7.13001 1.38C6.40001 2.34 6.10001 3.3 5.99001 4C6.27001 4.07 6.52001 4.29 6.64001 4.61C6.83001 5.09 6.64001 5.62 6.23001 5.78C5.82001 5.94 5.33001 5.68 5.14001 5.2C5.03001 4.91 5.05001 4.61 5.17001 4.38C3.74001 3.35 2.45001 3.86 2.45001 3.86C4.84001 5.69 5.55001 8.65 5.55001 8.65L7.77001 7.25L11.11 5.96L13.19 5.67C13.19 5.67 11.71 2.99 12.24 0.03Z"
        fill="url(#paint4_linear_3026_520)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.29001 5.75C6.29001 5.75 6.25001 5.77 6.23001 5.78C5.82001 5.94 5.33001 5.68 5.14001 5.2C5.03001 4.91 5.05001 4.61 5.17001 4.38C4.01001 3.54 2.90001 3.7 2.45001 3.86C2.45001 3.86 2.57001 3.82 2.57001 3.81C2.57001 3.81 3.86001 3.3 5.29001 4.33C5.17001 4.56 5.15001 4.86 5.26001 5.15C5.44001 5.61 5.89001 5.87 6.29001 5.76V5.75Z"
        fill="url(#paint5_linear_3026_520)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7 4.03C10.7 4.03 10.74 4.02 10.76 4.01C11.17 3.85 11.36 3.33 11.17 2.84C11.06 2.55 10.84 2.34 10.6 2.26C10.88 0.85 11.8 0.22 12.24 0.03L12.12 0.08C12.12 0.08 10.83 0.58 10.47 2.3C10.71 2.39 10.93 2.6 11.04 2.88C11.22 3.34 11.06 3.84 10.69 4.02L10.7 4.03Z"
        fill="url(#paint6_linear_3026_520)"
      />
      <g filter="url(#filter0_d_3026_520)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.28 5.48C13.17 5.2 11.31 5.67 9.12003 6.52C6.93003 7.37 5.25003 8.29 5.36003 8.57C5.36003 8.57 5.43003 8.76 5.45003 8.8C5.44003 8.65 5.74003 8.44 5.74003 8.44C6.34003 8.02 7.60003 7.38 9.14003 6.78C10.68 6.18 12.1 5.73 12.87 5.65C12.87 5.65 13.29 5.58 13.36 5.71L13.27 5.48H13.28Z"
          fill="url(#paint7_linear_3026_520)"
        />
      </g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.37 5.71C13.45 5.92 13.47 5.16 9.31001 6.81C5.77001 8.22 5.48001 8.88 5.45001 8.79C5.35001 8.51 7.03001 7.6 9.21001 6.74C11.39 5.88 13.26 5.42 13.37 5.7V5.71Z"
        fill="url(#paint8_linear_3026_520)"
      />
      <path
        opacity="0.7"
        d="M8.8902 2.72191C8.97436 2.54789 8.71208 2.24698 8.30438 2.04981C7.89669 1.85263 7.49796 1.83386 7.4138 2.00787C7.32964 2.18189 7.59192 2.4828 7.99961 2.67998C8.40731 2.87715 8.80604 2.89593 8.8902 2.72191Z"
        fill="white"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6.47 7.72C6.47 7.72 9.1 6.46 11.02 5.92C12.94 5.38 13.27 5.47 13.27 5.47C13.27 5.47 13.08 5.21 11.08 5.8C8.74 6.5 6.47 7.73 6.47 7.73V7.72Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_3026_520"
        x="-9.64508"
        y="-4.60099"
        width="28.0051"
        height="23.401"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.847059 0 0 0 0 0.54902 0 0 0 0 0.207843 0 0 0 0.5 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3026_520" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_3026_520"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_3026_520"
        x1="5.44886"
        y1="8.7902"
        x2="13.3688"
        y2="5.70394"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3026_520"
        x1="5.5959"
        y1="8.75437"
        x2="13.227"
        y2="5.78067"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3026_520"
        x1="4.61161"
        y1="5.01667"
        x2="7.09939"
        y2="4.04723"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#CC8A29" />
        <stop offset="1" stop-color="#974201" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3026_520"
        x1="11.3653"
        y1="1.71945"
        x2="9.17172"
        y2="4.27"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#EAAE29" />
        <stop offset="1" stop-color="#D17601" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3026_520"
        x1="3.34229"
        y1="6.16598"
        x2="13.1444"
        y2="2.34629"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FADA40" />
        <stop offset="0.03" stop-color="#F1C734" />
        <stop offset="0.12" stop-color="#DD9A18" />
        <stop offset="0.19" stop-color="#D07E06" />
        <stop offset="0.23" stop-color="#CC7400" />
        <stop offset="0.29" stop-color="#DC7C00" />
        <stop offset="0.34" stop-color="#EC8500" />
        <stop offset="0.39" stop-color="#EE950C" />
        <stop offset="0.47" stop-color="#F5C12D" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.71" stop-color="#FFFBE2" />
        <stop offset="0.73" stop-color="#FDF3C5" />
        <stop offset="0.78" stop-color="#FBE699" />
        <stop offset="0.82" stop-color="#F9DC74" />
        <stop offset="0.87" stop-color="#F8D558" />
        <stop offset="0.91" stop-color="#F7CF44" />
        <stop offset="0.96" stop-color="#F7CC38" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3026_520"
        x1="3.07262"
        y1="3.29818"
        x2="5.98818"
        y2="6.20817"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FCE3A1" />
        <stop offset="0.07" stop-color="#FCDF8B" />
        <stop offset="0.18" stop-color="#FCD96F" />
        <stop offset="0.25" stop-color="#FDD865" />
        <stop offset="0.48" stop-color="#FDE19B" />
        <stop offset="0.83" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_3026_520"
        x1="11.4052"
        y1="0.0492826"
        x2="11.2273"
        y2="4.16472"
        gradientUnits="userSpaceOnUse">
        <stop offset="0.24" stop-color="#FCE3A1" />
        <stop offset="0.28" stop-color="#FCDF8B" />
        <stop offset="0.34" stop-color="#FCD96F" />
        <stop offset="0.38" stop-color="#FDD865" />
        <stop offset="0.55" stop-color="#FFEBA8" />
        <stop offset="0.72" stop-color="#C97902" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint7_linear_3026_520"
        x1="4.92562"
        y1="8.3287"
        x2="13.0505"
        y2="5.16257"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9D83F" />
        <stop offset="0.11" stop-color="#F2AB1D" />
        <stop offset="0.2" stop-color="#ED8F07" />
        <stop offset="0.25" stop-color="#EC8500" />
        <stop offset="0.48" stop-color="#F7CB34" />
        <stop offset="0.69" stop-color="#FCF2BD" />
        <stop offset="1" stop-color="#F7CB34" />
      </linearGradient>
      <linearGradient
        id="paint8_linear_3026_520"
        x1="5.35811"
        y1="8.55726"
        x2="13.278"
        y2="5.471"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#F9CE3E" />
        <stop offset="0.12" stop-color="#E5A11D" />
        <stop offset="0.2" stop-color="#D98508" />
        <stop offset="0.25" stop-color="#D57B01" />
        <stop offset="0.48" stop-color="#F2BE34" />
        <stop offset="0.69" stop-color="#FCD745" />
        <stop offset="1" stop-color="#D37900" />
      </linearGradient>
      <clipPath id="clip0_3026_520">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
